import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-credits-history',
  templateUrl: './credits-history.component.html',
  styleUrls: ['./credits-history.component.css']
})
export class CreditsHistoryComponent implements OnInit {

  currentUser: any = {};
  dataresult: any[] = [];
  showLoader: boolean = false;
  p: number = 1;
  recordsperpage: number = 25;

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  constructor(
    private router: Router,
    private loginservice: LoginService
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (!this.currentUser) {
      this.router.navigate(['/login']);
      return;
    }
    this.loadHistory();
  }

  loadHistory() {
    this.showLoader = true;
    this.loginservice.getCreditsHistory(this.currentUser).subscribe(
      data => {
        this.dataresult = data['data'] || [];
        this.showLoader = false;
      },
      error => {
        alert('Network Error getCreditsHistory API');
        this.showLoader = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/credits-history/credits-history.component.ts